module.exports = __webpack_public_path__ + "static/img/8.246f068.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu_shenfree/8.png
// module id = nlR0
// module chunks = 0